import React from 'react';
import { Grid, Typography } from '@mui/material';

const RatingButtons = ({ active, setActive, activeColor, isReadOnly }) => {
  const buttons = [1, 2, 3, 4, 5];

  return (
    <Grid display="flex" alignItems="center" justifyContent={'space-between'} gap="25px" pb="8px" pl="15px">
      {buttons.map(num => (
        <Grid
          key={num}
          width="40px"
          height="40px"
          borderRadius="50%"
          border="1px solid #8894ab"
          display="flex"
          alignItems="center"
          justifyContent="center"
          bgcolor={active === num ? activeColor : 'white'}
          style={{ cursor: 'pointer' }}
          onClick={isReadOnly ? undefined : () => setActive(num)}
        >
          <Typography variant="subtitle1" pt="4px" color={active === num ? 'white' : '#8894ab'}>
            {num}
          </Typography>
        </Grid>
      ))}
    </Grid>
  );
};

export default RatingButtons;
